import React from 'react';

const InputField = ({ label, name, value, onChange, error, type = 'text', disabled }) => (
  <div className="form-group">
    <label>
      {label}
      {error && <span className="error-text"> {error}</span>}
    </label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      className={error ? 'input-error' : ''}
      disabled={disabled}
    />
  </div>
);


export default InputField;
